export default function Footer() {
  return (
    <footer className="footer body__element">
      <p className="footer__copyright">&copy; 2021 Максим Толстокорый</p>
    </footer>
  );
}
